import React, { useEffect, useRef, useState } from 'react';
import Pagination from '../Header/Pagination';
import Modal from 'react-responsive-modal';
import DeleteDialogueBox from '../Common/deleteDialogue';
import royContractServices from './royContractServices';

export function EscalationRate(Escalation: any) {

    var [deleteJob, setdeleteJob] = useState<any>([]);
    const [saveAlert, setSaveAlert] = useState(false);
    const formValidation = useRef<HTMLDivElement>(null);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [fieldsInvalid, setfieldsInvalid] = useState(false);
    let [EscalationTotalRow, setEscalationTotalRow] = useState(0);
    let [EscalationListing, setEscalationListing] = useState<any>([]);
    let [editEscalationRate, seteditEscalationRate] = useState<any>([]);

    var payload = {
        pageNumber: 1,
        pageSize: 10,
        formatId: 'ALL'
    }
    const handleNameOnChange = (n: any) => {
        payload.pageNumber = n.pageNumber;
        payload.pageSize = n.pageSize;
        console.log(payload);
    }

    useEffect(() => {
        console.log(Escalation)

        if (Escalation.data.contractRefNum) {
            formatEvaluationListing();
        }
    }, []);

    const closeEscalation = () => {
        Escalation.closeEscalation()
    }

    const formatEvaluationListing = () => {
        royContractServices.formatevaluation(Escalation.data.contractRefNum, payload).then((res: any) => {
            setEscalationListing(res)
            setEscalationTotalRow(res ? res.length : 0)
        })
    }

    const formatEvaluationSave = () => {

        if (!editEscalationRate.formatID) {
            editEscalationRate['formatID'] = Escalation.data.format;
        }

        var valid = handleFieldRequired(editEscalationRate)

        if (valid) {
            editEscalationRate.kontactCode = Escalation.data.contractRefNum;
            royContractServices.formatevaluationSave(Escalation.data.contractRefNum, editEscalationRate).then(() => {
                setSaveAlert(true);
                formatEvaluationListing();
            })

            setTimeout(function () {
                setSaveAlert(false);
                setfieldsInvalid(false);
            }, 3000);

        }

    }

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...editEscalationRate };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        editEscalationRate = updatedObject;
        seteditEscalationRate(editEscalationRate);


    };

    const handleSpecificField = (fieldName: any, value: any, object: any) => {
        console.log(fieldName)
        console.log(object)
        console.log(value)

        let updatedObject = { ...editEscalationRate }
        if (fieldName === 'groupDesc,territoryCode') {
            var found = object.filter((event: any) => (event.groupDesc === (value)));
            updatedObject.groupDesc = found[0].groupDesc
            updatedObject.territoryCode = found[0].groupingId
        }

        if (fieldName === 'UsePriceDesc,usePrice') {
            var found = object.filter((event: any) => (event.value === (value)));
            updatedObject.UsePriceDesc = found[0] && found[0].value ? found[0].value : ''
            updatedObject.usePrice = found[0] && found[0].key ? found[0].key : ''
        }


        if (fieldName === 'formatDesc,format') {
            var found = object.filter((event: any) => (event.formatDesc === (value)));
            updatedObject.formatDesc = found[0].formatDesc
            updatedObject.format = found[0].codingStr
        }

        editEscalationRate = updatedObject;
        seteditEscalationRate(editEscalationRate);
    }

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })

        if (!valid) {
            setfieldsInvalid(true)
        }
        return valid;
    }

    const clearSForm = () => {
        editEscalationRate = {}
        seteditEscalationRate(editEscalationRate)
        const inputs: any = formValidation.current?.querySelectorAll('input');
        if (inputs) {
            Object.values(inputs).map((values: any) => {
                var fieldName: any = document.getElementById(values.id);
                if (fieldName) {
                    fieldName.style.border = "1px solid #47529d";
                }


            })
        }

    };

    const Confirmation = (e: any) => {
        console.log(deleteJob)
        if (e === 1) {
            royContractServices.formatevaluationDelete(Escalation.data.contractRefNum, deleteJob?.formatEvaluationID).then(() => {
                setDeleteAlert(true);
                formatEvaluationListing();
            })
            setTimeout(function () {
                setDeleteAlert(false);
            }, 3000);
        }

        setdeleteJob({});
    };

    return (

        <>
            <Modal open={Escalation.openEscalation} onClose={() => closeEscalation()} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >

                <div className='ws-12 box'>

                    <div className="row-fluid ">

                        <div className="box-header-main well"> <h2><i className="fa fa-info"></i> Escalation</h2> </div>

                        <div className="box-content form-box">
                            <div className="row-fluid" ref={formValidation}>

                                {fieldsInvalid && <div className="alert alert-danger">
                                    There was a problem submitting your request, one or more fields are missing or incorrect.
                                </div>}

                                <div className="form-format">
                                    <label className="control-label">Format</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge focused span" value={Escalation.data.format} type="text" id="contractFormat" name="contractFormat" readOnly />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label" >Lower Limit*</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge focused span" value={editEscalationRate.lowerLimit} onChange={(e) => handleFieldChange(e)} type="text" placeholder="Enter lower limit" id="lowerLimit" name="lowerLimit" required />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label">Upper Limit*</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge focused span" value={editEscalationRate.upperLimit} onChange={(e) => handleFieldChange(e)} type="text" placeholder="Enter upper limit" id="upperLimit" name="upperLimit" required />
                                    </div>
                                </div>

                                <div className="form-format">
                                    <label className="control-label" >Escalated Rate*</label>
                                    <div className="label-entries">
                                        <input className="input-xlarge focused span" value={editEscalationRate.discount} onChange={(e) => handleFieldChange(e)} placeholder="Enter escalated rate" type="text" id="discount" name="discount" required />
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div className="box-footer">
                            <button className="icon-btn delete btn-sm" onClick={() => { clearSForm() }}><i className="fa fa-refresh"></i> Reset</button>

                            <button className="icon-btn edit btn-sm" onClick={formatEvaluationSave}><i className="fa fa-save"></i> Save</button>
                        </div>
                    </div>

                    <div className="row-fluid">
                        <div className="ws-12">
                            <div className="box-header well"> <h2> <span>0 record(s) found</span> </h2> </div>

                            <div className="box-content">
                                {deleteAlert && <div className="alert alert-success"> Escalation with lower limit  has been deleted successfully</div>}
                                {saveAlert && <div className="alert alert-success" > Escalation with lower limit  has been saved successfully</div>}
                                {(EscalationListing.length === 0) && <div className="alert alert-info" >No records to display</div>}
                                {(EscalationListing.length > 0) && <div className="table-responsive" >
                                    <table className="newTable">
                                        <thead>
                                            <tr>
                                                <th>Lower Limit</th>
                                                <th>Upper Limit</th>
                                                <th>Discount(%)</th>
                                                <th>Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                EscalationListing?.map((values: any) => {
                                                    return (
                                                        <tr>
                                                            <td> {values.lowerLimit}</td>
                                                            <td> {values.upperLimit}</td>
                                                            <td> {values.discount}</td>
                                                            <td>
                                                                <a onClick={() => seteditEscalationRate(values)} className="icon-btn edit height35"><i className="icon-edit1"></i></a>
                                                                <a onClick={() => setdeleteJob(values)} className="icon-btn delete height35"><i className="icon-trashcan"></i></a>
                                                            </td>

                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>}
                                <div className="clearfix">
                                    {(() => {

                                        if (EscalationTotalRow > 1 && EscalationTotalRow > 10) {
                                            return  <Pagination onPageChange={handleNameOnChange} totalRow={EscalationTotalRow} />
                                        }

                                        if (deleteJob && deleteJob.formatEvaluationID) {
                                            return <DeleteDialogueBox param={true} message={"delete evaluation " + deleteJob.lowerLimit + " to " + deleteJob.upperLimit} onChange={Confirmation} />
                                        }

                                    })()}
                                </div>
                            </div>

                            <div className="box-footer">
                                <button className="icon-btn delete width90 height35" onClick={() => closeEscalation()}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>

            </Modal>
        </>
    )
}